import { BookingDialogActionType } from "../Actions";
import { BookingDialogStep, ITimetableState } from "../Models";
import { SearchActionType } from "../Search/Actions";


export const createTimetableReducer = (initialState: ITimetableState = null) => {

	initialState = setInitialState(initialState);

	return (state: ITimetableState = initialState, action: { type?: SearchActionType|BookingDialogActionType }): ITimetableState => {
		switch(action.type) {
			case "searchJourneyComplete":
				return { ...state, ...{ searchJourneyResult: (action as any).payload }};
			case "setStep":
				const step = (action as any).step as BookingDialogStep;
				if (step === "search")
					return { ...state, ...{ searchJourneyResult: undefined }}; //Töm state om vi går tillbaka till search
				else
					return state;
			default:
				return state;
		}
	};

	function setInitialState(initialState: ITimetableState): ITimetableState {
		return {...initialState, ...{ }};
	}
};